import React, { useState, useContext } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import MakeBidDialogue from "./make-bid-dialogue";
import PremPlayersContext from "../../contexts/premplayers-context";
import SettledWindowTransactionsContext from "../../contexts/settled-window-transactions-context";
import UserPendingTransactionsContext from "../../contexts/user-pending-transactions-context";
import { LeaderboardContext } from "../../contexts/leaderboard-context";
import { useSiteVarsFunctions } from "../../hooks/use-site-vars-functions";

export const MakeBid = ({setNavValue}) => {
  const {getPlayerPositionById, getTeamById, getCurrentWindow } = useSiteVarsFunctions();
  const [isMakeBidDialogueOpen, setMakeBidDialogueIsOpen] = useState(false);
  const [selectedPlayerData, setSelectedPlayerData] = useState({});
  const {premPlayersData, isLoadingPremPlayersData} =  useContext(PremPlayersContext);
  const {leaderboardData} = useContext(LeaderboardContext);
  const {settledWindowTransactionsData, isLoadingSettledWindowTransactionsData} = useContext(SettledWindowTransactionsContext);
  const {userPendingTransactionsData, isLoadingUserPendingTransactionsData} = useContext(UserPendingTransactionsContext);

  //Filter out the players which are already owned by a club
  let ownedPlayers = [];
  let filteredOwnedPlayers = [];
  for(let i = 0; i < leaderboardData.length; i++) {
    ownedPlayers = ownedPlayers.concat(leaderboardData[i].players);
  }
  
  for(let i = 0; i < ownedPlayers.length; i++) {
    if(ownedPlayers[i].transfer != "in") {
      filteredOwnedPlayers.push(ownedPlayers[i].playerId);
    }
  }
  let filteredPremPlayersData = premPlayersData.filter(player => !filteredOwnedPlayers.includes(player.playerId));

  //filter out players which have already been bought in this window
  let purchasedPlayers = [];
  if(settledWindowTransactionsData.Items === undefined) {
    settledWindowTransactionsData.Items = [];
  }
  for(let i = 0; i < settledWindowTransactionsData.Items.length; i++) {
    let purchasedPlayer = settledWindowTransactionsData.Items[i];
    if(purchasedPlayer.status === "win") {
      purchasedPlayers.push(purchasedPlayer.playerId);
    }
  }
  
  filteredPremPlayersData = filteredPremPlayersData.filter(player => !purchasedPlayers.includes(player.playerId));

  // Sort the filtered players
  filteredPremPlayersData.sort((a, b) => {
    if (a.positionId !== b.positionId) {
      return a.positionId - b.positionId; // Sort by positionId ascending
    }
    if (a.originalCost !== b.originalCost) {
      return b.originalCost - a.originalCost; // Then by originalCost descending
    }
    return b.totalPoints - a.totalPoints; // Then by totalPoints descending
  });

  //get the userid's of the users pending transactions
  let pendingTransactions = [];
  let windowBidCount = 0;
  if(userPendingTransactionsData.Items === undefined) {
    userPendingTransactionsData.Items = [];
  }
  for(let i = 0; i < userPendingTransactionsData.Items.length; i++) {
    let pendingTransaction = userPendingTransactionsData.Items[i];
    if(pendingTransaction.window == getCurrentWindow()) {
      if(pendingTransaction.status === "pending") {
        pendingTransactions.push(pendingTransaction.playerId);
        windowBidCount++;
      } else if(pendingTransaction.status === "win") {
        windowBidCount++;
      }
    }
  }

  return (
      <TableContainer component={Paper} sx={{ marginBottom:5 }}>
      {isMakeBidDialogueOpen && (
        <MakeBidDialogue open={isMakeBidDialogueOpen} playerId={selectedPlayerData.playerId} handleCloseMakeBidDialogue={setMakeBidDialogueIsOpen} setNavValue={setNavValue} />
      )}
      {(isLoadingPremPlayersData || isLoadingSettledWindowTransactionsData || isLoadingUserPendingTransactionsData) && (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width={"100%"} height={30} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
        </Stack>
      )}
      {(!isLoadingPremPlayersData && !isLoadingSettledWindowTransactionsData && !isLoadingUserPendingTransactionsData) && (
      <Table sx={{ minWidth: 390 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ paddingLeft: 6, paddingRight:0}}></TableCell>
            <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Player</TableCell>
            <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Cost</TableCell>
            <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Points</TableCell>
            <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredPremPlayersData.map((row) => (
            //row.transfer != "in" && (
              <TableRow key={row.playerId}>
              <TableCell style={{ paddingLeft: 6, paddingRight:0}}>
                <img src={`https://fantasy.premierleague.com/dist/img/shirts/standard/shirt_${getTeamById(row.teamId).kitId}${getPlayerPositionById(row.positionId).name_short === "GKP" ? "_1" : ""}-66.webp`} style={{ width: '40px', height: '40px' }} />
              </TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}><span>{row.lastName}</span>
                <br />
                <span style={{fontWeight: 'bold'}}>{getPlayerPositionById(row.positionId).name_short}</span> {getTeamById(row.teamId).name_short}</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{row.originalCost}</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{row.totalPoints}</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}><Button variant="outlined" size="small" disabled={windowBidCount >= 4 || pendingTransactions.includes(row.playerId)}onClick={() => {setSelectedPlayerData(row); setMakeBidDialogueIsOpen(true)}}>Bid</Button></TableCell>
            </TableRow>
            //)
          ))}
        </TableBody>
      </Table>
      )}
      
    </TableContainer>
  );
};
